var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container resource info faq"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("We sturen je door naar "+_vm._s(_vm.$route.params.slug)+"!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }